export default __webpack_public_path__ + "static/media/admin-gestao-usuarios-on.240be38a.svg";